import locator from '@/service-locator'
import MerchantProfileApi from '@/api/merchant/profile'
import MERCHANT_TYPE from '@/constants/merchant-type'
import { getOperatingSystem, getDeviceType } from '@/utils/device-type'
const state = {
  data: {},
  fetched: false,
  fetching: false,
  error: null,
}

const getters = {
  profile: (state) => {
    return state.data || {}
  },
  inStoreDirectIntegrationEnabled: (state) => {
    return state.data?.inStoreDirectIntegrationEnabled
  },
  merchantTier(_, getters) {
    const tierInfo = getters.profile?.tier

    return tierInfo?.tier || ''
  },
  merchantTypes(_, getters) {
    return getters.profile?.merchantTypes || []
  },
  isMerchantOnline(_, getters) {
    return getters.merchantTypes.includes(MERCHANT_TYPE.online)
  },
  isMerchantInStore(_, getters) {
    return getters.merchantTypes.includes(MERCHANT_TYPE.in_store)
  },
  merchantCountryCode(_, getters) {
    return getters.profile.country || ''
  },
}

const mutations = {
  SET_STATUS: (state, { key, value }) => {
    state[key] = value
  },
  SET_MERCHANT_DATA: (state, data) => {
    state.data = data
  },
  SET_MERCHANT_ERROR: (state, error) => {
    state.error = error
  },
}

const actions = {
  async getProfile({ commit }) {
    try {
      // checking for essential data from /profile api
      if (state.data && state.data.merchantId && state.data.merchantName) {
        return state.data
      }

      commit('SET_STATUS', { key: 'fetching', value: true })

      const { data } = await MerchantProfileApi.getProfile()

      commit('SET_STATUS', { key: 'fetched', value: true })
      commit('SET_STATUS', { key: 'fetching', value: false })
      commit('SET_MERCHANT_DATA', data)

      locator.chatbot.setChatMetaFields({
        merchant_authenticated_status: true,
        merchant_name: data.merchantName || '',
        merchant_id: data.merchantId || '',
        merchant_tier: data.tier || '',
        merchant_code: data.merchantCode || '',
        merchant_platform: data.platform || '',
      })

      locator.tracking.identify(data.merchantId, {
        brand_name: data.merchantName || '',
        merchant_code: data.merchantCode || '',
        merchant_authenticated_status: true,
        merchant_platform: data.platform || '',
        country_code: data.country || '',
        operating_system: getOperatingSystem(),
        device_type: getDeviceType(),
      })
    } catch (error) {
      commit('SET_MERCHANT_ERROR', error)
    }
  },
  resetProfile({ commit }) {
    commit('SET_MERCHANT_DATA', {})
  },
}

export default { namespaced: true, state, getters, mutations, actions }
